import React from 'react'
import { ButtonField } from '@/payload-types'
import { CMSLink } from '@/ui/components/CMSLink'
import { PopUpButton } from '@/ui/components/Dialog/popUpButton'
import { TypedLocale } from 'payload'

export interface CMSButtonPropsType extends ButtonField {
  className?: string
  key?: React.Key
  locale?: TypedLocale
}

export const CMSButton: React.FC<CMSButtonPropsType> = (props) => {
  return (
    <React.Fragment>
      {props.linkType === 'link' && <CMSLink {...props} />}
      {props.linkType === 'popup' && props.locale && (
        <PopUpButton {...(props as CMSButtonPropsType & { locale: TypedLocale })} />
      )}
    </React.Fragment>
  )
}
